<script setup>
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { ref, onMounted } from "vue";
import ChangeDevices from "@/components/Common/ChangeDevices.vue";
import { EventManager, Actions, Events } from "@events";
import i18n from "@/i18n";
import { useVideoCallState } from "@/stores/videoCallState";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});
const state = useVideoCallState(props.rtcId);

const isDisabled = ref(false);
const dialog = ref(false);

let eventEmitter = null;

function openDialog() {
  dialog.value = true;
}

async function closeDialog(save) {
  dialog.value = false;
}

onMounted(async () => {
  eventEmitter = EventManager.getEventEmitter(props.rtcId);

  eventEmitter.on(Events.ScreenShareStarted, async () => {
    isDisabled.value = true;
  });

  eventEmitter.on(Events.ScreenShareFinished, async () => {
    isDisabled.value = false;
  });
});
</script>

<template>
  <VideoCallButton :disabled="isDisabled || state.disableVideoControls" icon="mdi-camera-switch" @click="openDialog()" />

  <v-dialog v-model="dialog" style="max-width: 700px">
    <v-card>
      <v-card-text>
        <change-devices></change-devices>
        <v-btn class="ml-5 mb-5" color="blue" @click="closeDialog(false)">{{ $t("Close") }}</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
